import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, spacing, breakpoints }) => ({
  footerContainer: {
    '& footer': {
      position: 'relative',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  mainContainer: {
    // backgroundColor: '#214865',
    // height: '100vh',
    // marginBottom: spacing(20),
  },
  rootText: {
    margin: spacing(3, 15.75, 0, 15.75),
    fontSize: spacing(6),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  buttonText: {
    fontSize: spacing(2.25),
    fontWeight: spacing(87.5),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: palette.green.dark,
    color: palette.white.main,
    letterHeight: spacing(2.68),
    letterSpacing: '0px',
    padding: spacing(1.25),
    '&:hover': {
      backgroundColor: palette.scorpionGray.dark,
    },
    [breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: spacing(3),
    // [breakpoints.up('lg')]: {
    //   margin: spacing(3, 20, 3, 10.25),
    // },
    // [breakpoints.up('xl')]: {
    //   margin: spacing(3, 7.5, 3, 10.25),
    // },
    // '@media (min-width:1200px) and (max-width:1535px)': {
    //   margin: spacing(3, 20, 3, 10.25),
    // },
    // '@media (min-width:1535px) and (max-width:1727px)': {
    //   margin: spacing(3, 7.5, 3, 10.25),
    // },
    // '@media (min-width:1900px)': {
    //   margin: spacing(3, 31.25, 3, 10.25),
    // },
    [breakpoints.down('sm')]: {
      // width: '100%',
      margin: spacing(1),
    },
  },
  buttonUpperContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: spacing(2),
    [breakpoints.down('sm')]: {
      margin: spacing(1),
    },
  },
  label: {
    // width: '100%',
    height: '100%',
    margin: spacing(3),
    // display: 'contents',
  },
  radioGroup: {
    display: 'grid',
    gridGap: spacing(3),
    [breakpoints.up('xl')]: {
      gridTemplateColumns: 'repeat(5, 458px)',
    },
    [breakpoints.down('xl')]: {
      gridTemplateColumns: 'repeat(3, 458px)',
    },
    [breakpoints.down('lg')]: {
      gridTemplateColumns: 'repeat(3, 458px)',
    },
    [breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 458px)',
    },
    [breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(1, 375px)',
      padding: spacing(2),
    },
    '@media (max-width:375px)': {
      width: '375px',
    },
    '@media (max-width:320px)': {
      width: '330px',
    },
    justifyContent: 'center',
    '& .MuiRadio-root': {
      display: 'none',
    },
  },
  templateContainer: {
    justifyContent: 'center',
    marginTop: '20px',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    margin: spacing(0),
    display: 'contents',
  },
  subHeader: {
    margin: spacing(1),
    fontSize: spacing(3.5),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.5),
      margin: spacing(1),
    },
  },
  subTitle: {
    margin: spacing(1),
    fontSize: spacing(2),
    fontWeight: spacing(50),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    [breakpoints.down('sm')]: {
      fontSize: spacing(1.75),
      margin: spacing(1),
    },
  },
  congratsTitle: {
    marginBottom: spacing(2),
    marginTop: spacing(2),
    fontSize: spacing(3.125),
    fontWeight: spacing(100),
    fontFamily: 'Open Sans',
    textAlign: 'center',
    color: '#623293',
    [breakpoints.down('sm')]: {
      fontSize: spacing(3),
      margin: spacing(2),
    },
  },
  templateCard: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Optional: example shadow
    borderRadius: '8px', // Optional: example rounding for the corners
  },
  logoImage: {
    [breakpoints.down('sm')]: {
      left: spacing(9),
      width: 'auto',
      height: '100px',
      top: spacing(2),
      // padding: spacing(1),
      marginTop: spacing(2),
      display: 'flex',
    },
    [breakpoints.up('sm')]: {
      display: 'none',
    },
    '@media (max-width:375px)': {
      padding: spacing(1.5),
    },
    '@media (max-width:320px)': {
      padding: spacing(1.5),
    },
  },
  logoContainer: {
    [breakpoints.down('sm')]: {
      // height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    [breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  containerX: {
    [breakpoints.up('sm')]: {
      marginTop: '30px',
    },
  },
  loaderResolution: {
    [breakpoints.down('xl')]: {
      height: '468px',
    },
    [breakpoints.down('lg')]: {
      height: '277px',
    },
    // [breakpoints.only('md')]: {
    //   height: '277px',
    // },
    [breakpoints.down('sm')]: {
      height: '150px',
    },
  },
}));
